'use strict'

import $ from 'jquery'
import 'jquery-match-height'

export default class EqualHeight{
  constructor(el) {
    this.$el = $(el)
    this.$el.children().matchHeight()
  } 
}
